import "./CheckOutPage.css";
import LeftCheckOut from "../components/CheckOut/LeftCheckOut";
import RightCheckOut from "../components/CheckOut/RightCheckOut";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import AboutThisProject from "../components/AboutThisProject";

function CheckOutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cart = useSelector((state) => state.cart);
  const totalPrice = cart
    .reduce((acc, product) => acc + product.qty * product.price, 0)
    .toFixed(2);
  const priceWithTaxes = (totalPrice * 1.1).toFixed(2);

  return (
    <div className="bg-light animate__animated animate__fadeIn">
      <AboutThisProject />
      <div className="container my-0">
        <div className="row justify-content-center checkout-page ps-lg-5">
          <div className="col-12 col-lg-7 order-2 order-lg-1 bg-white border-start border-end border-top mt-4 mt-lg-0">
            <LeftCheckOut
              totalPrice={totalPrice}
              cart={cart}
              priceWithTaxes={priceWithTaxes}
            />
          </div>
          <div className="col-lg-5 order-lg-2 bg-light">
            <RightCheckOut
              totalPrice={totalPrice}
              cart={cart}
              priceWithTaxes={priceWithTaxes}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckOutPage;
